/**
 * A per-action idempotency key for till operations.
 *
 * The contract everywhere it is used: generate ONE key per intended action and
 * regenerate it only after that action SUCCEEDS. A double-tap, a re-submit
 * after a slow response, or a retry over a flaky in-store wifi then carries the
 * same key, and the server collapses it onto the original ledger row instead of
 * charging or awarding twice.
 *
 * crypto.randomUUID is missing on the older Android tablets these tills run on,
 * hence the fallback — which is not cryptographic and does not need to be: the
 * key only has to be unique among one till's own recent actions.
 */
export function newIdempotencyKey() {
  try {
    if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  } catch (_) { /* fall through */ }
  return `k-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
}

export default newIdempotencyKey;
